import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Col, message, Radio, Row, Spin, Switch } from 'antd';
import MessageConfirmModal from '../messageModal/MessageConfirmModal';
import InputComponent from '../input/InputComponent';
import { useNavigate, useParams } from 'react-router-dom';
import { COUPON_URL, PRODUCT_CATEGORY_URL, PRODUCT_URL } from '../../api/URLs';
import { getDataRequest, postDataRequest, putDataRequest } from '../../api/serviceMethods';
import SelectComponent from '../select/SelectComponent';
import DragUploadComponent from '../upload/DragUploadComponent';
import TextAreaComponent from '../input/TextAreaComponent';
import HeaderCreateStaffComponent from '../header/HeaderCreateStaffComponent';
import OSSUploadWrapper from '../upload/OSSUploadWrapper';
import InputNumberComponent from '../input/InputNumberComponent';
import DateComponent from '../date/DateComponent';
import dayjs from 'dayjs';

function NewCoupon() {
    const { newStep } = useParams();
    const { t } = useTranslation();
    const { id } = useParams();
    const messageModalRef = useRef("");
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [categoryId, setCategoryId] = useState([])
    const today = new Date().toISOString().split('T')[0];

    const [dataObject, setDataObject] = useState({
        totalQuantity: '',
        discountValue: '',
        discountType: 'member_discount',
        validityType: 'days', // 'days' | 'date_range'
        validDays: '',
        validFrom: today,
        validTo: null,
        remarks: ''
    });

    const checkError = () => {
        if (
            !dataObject.totalQuantity ||
            !dataObject.discountValue ||
            !dataObject.discountType ||
            !dataObject.remarks
        ) {
            return true;
        }

        if (dataObject.validityType === "days") {
            return !dataObject.validDays;
        }

        if (dataObject.validityType === "date_range") {
            return !dataObject.validFrom || !dataObject.validTo;
        }

        return false;
    };
    const insertParams = () => {
        const payload = {
            totalQuantity: dataObject.totalQuantity,
            discountValue: dataObject.discountValue,
            discountType: dataObject.discountType,
            validityType: dataObject.validityType,
            remarks: dataObject.remarks
        };
        if (dataObject.validityType === 'days') {
            payload.validDays = dataObject.validDays;
        } else if (dataObject.validityType === 'date_range') {
            payload.validTo = dataObject.validTo;
            payload.validFrom = dataObject.validFrom;
        }
        return payload;
    };
    // Save member
    const handleSubmit = async () => {
        setIsSubmit(true)
        if (checkError()) {
            return false
        }
        setLoading(true);
        const couponPayload = insertParams()
        try {
            const res = await postDataRequest(COUPON_URL, couponPayload);
            console.log("res", res.status)
            if (res.status === 200) {
                setLoading(false);
                messageModalRef.current.showSuccessConfirmsAutoClose(t("Saved Successfully"), () => { }, "", true);
                setTimeout(() => {
                    navigate("/coupon")
                }, 2000);
            } else {
                messageModalRef.current.showWarningConfirmsAutoClose(res && res.data?.message || res.message || t("An error occurred."), () => { }, "", true);
                setLoading(false)
            }
        } catch (err) {
            console.log("err", err)
            messageModalRef.current.showWarningConfirmsAutoClose(err && err?.message === "\"validTo\" must be greater than \"ref:validFrom\"" ? "Date to must be greater than Current day" :err && err?.message, () => { }, "", true);
            setLoading(false)
        } finally {
            setLoading(false);
            setIsSubmit(false);
        }
    }
    const discountTypeOptions = [
        { label: '会员折扣', value: 'member_discount' },
    ];

    useEffect(() => {
        if (dataObject.validityType !== "date_range") {
            setDataObject(prev => ({
                ...prev,
                validFrom: null,
                validTo: null,
            }));
        }

        if (dataObject.validityType !== "days") {
            setDataObject(prev => ({
                ...prev,
                validDays: "",
            }));
        }
    }, [dataObject.validityType]);


    return (
        <>
            <HeaderCreateStaffComponent
                bntTitle={<>
                    <Button
                        className='b-danger'
                        disabled={loading}
                        type="primary"
                        onClick={handleSubmit}
                        style={{
                            fontSize: '16px',
                            backgroundColor: "#E50A47",
                            border: "1px solid #e72158",
                            color: "#FFFFFF",
                            opacity: loading ? '0.4' : ""
                        }}
                        danger
                    >
                        {t("Submit")}
                    </Button>
                </>}
                isHide="view"
                onClick={() => {
                    navigate('/coupon')
                }}
                backTitle={t('Batch Create Coupons')}
            >
                <Spin spinning={loading}>
                    {
                        !newStep || newStep - 0 === 1 ? <div className='container newDetail'>

                            <Row className='mt-4 d-flex align-items-center'>
                                <Col md={4}>{t("Coupon Quantity")} :</Col>
                                <Col md={20}>
                                    <InputNumberComponent
                                        value={dataObject.totalQuantity}
                                        setValue={(val) => setDataObject({ ...dataObject, totalQuantity: val })}
                                        status={isSubmit && !dataObject.totalQuantity && "error"}
                                        placeholder=""
                                    />
                                </Col>
                            </Row>
                            <Row className='mt-4 d-flex align-items-center'>
                                <Col md={4}>{t("Coupon Discount")} :</Col>
                                <Col md={20}>
                                    <InputNumberComponent 
                                        status={isSubmit && !dataObject.discountValue && `error`} 
                                        suffix="%"
                                        value={dataObject.discountValue}
                                        setValue={(value) => setDataObject({ ...dataObject, discountValue: value })} placeholder=""
                                        max={100}
                                        min={1}
                                    />
                                </Col>
                            </Row>
                            <Row className='mt-4 d-flex align-items-center'>
                                <Col md={4}>{t("Discount Type")} :</Col>
                                <Col md={20}>
                                    <SelectComponent
                                        options={discountTypeOptions}
                                        value={dataObject.discountType}
                                        setValue={(val) => setDataObject({ ...dataObject, discountType: val })}
                                        status={isSubmit && !dataObject.discountType && "error"}
                                        placeholder=""
                                    />
                                </Col>
                            </Row>
                            <Row className='mt-4 d-flex align-items-start'>
                                <Col md={4}>{t("Validity")} :</Col>
                                <Col md={20}>
                                    <Radio.Group
                                        onChange={(e) => setDataObject({ ...dataObject, validityType: e.target.value })}
                                        value={dataObject.validityType}
                                        className="d-flex flex-column"
                                    >
                                        <Radio value="days" className="mb-3 d-flex align-items-center">
                                            <div className="d-flex align-items-center">
                                                <InputNumberComponent
                                                    min={1}
                                                    value={dataObject.validDays}
                                                    setValue={(val) => {
                                                        setDataObject(prev => ({
                                                            ...prev,
                                                            validDays: prev.validityType === 'days' ? val : '',
                                                        }));
                                                    }}
                                                    disabled={dataObject.validityType !== 'days'}
                                                    placeholder={t('Please enter the number of days')}
                                                    status={isSubmit && dataObject.validityType === 'days' && !dataObject.validDays ? "error" : ""}
                                                />
                                                <span className="ms-2">{t('day')}</span>
                                            </div>
                                        </Radio>
                                        <Radio value="date_range" className="d-flex align-items-center">
                                            <DateComponent
                                                disabled={dataObject.validityType !== "date_range"}
                                                value={dataObject.validTo}
                                                setValue={(date) =>
                                                    setDataObject(prev => ({
                                                        ...prev,
                                                        validTo:
                                                            prev.validityType === "date_range" && date
                                                                ? dayjs(date).format("YYYY-MM-DD")
                                                                : null,
                                                    }))
                                                }
                                                status={
                                                    isSubmit &&
                                                        dataObject.validityType === "date_range" &&
                                                        !dataObject.validTo
                                                        ? "error"
                                                        : ""
                                                }
                                            />
                                        </Radio>
                                    </Radio.Group>

                                </Col>
                            </Row>
                            <Row className='mt-4 d-flex align-items-start'>
                                <Col md={4}>{t("Remark")} :</Col>
                                <Col md={20}>
                                    <TextAreaComponent className={`mb-2`} status={isSubmit && !dataObject.remarks && `error`} value={dataObject.remarks}
                                        setValue={(value) => setDataObject({ ...dataObject, remarks: value })} placeholder="" />
                                </Col>
                            </Row>
                        </div>
                            :
                            ""
                    }
                    <MessageConfirmModal textCentered ref={messageModalRef} />
                </Spin>
            </HeaderCreateStaffComponent>
        </>
    );
}

export default NewCoupon;
